"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FooterPayMethodImage = function (_a) {
    var _b, _c;
    var method = _a.method, onClick = _a.onClick, getPaymentImagePath = _a.getPaymentImagePath;
    var logoBrand = (_b = method === null || method === void 0 ? void 0 : method.images) === null || _b === void 0 ? void 0 : _b.logoBrand;
    var logo = (_c = method === null || method === void 0 ? void 0 : method.images) === null || _c === void 0 ? void 0 : _c.logo;
    var localSrc = getPaymentImagePath((method === null || method === void 0 ? void 0 : method.slug) || '');
    var _d = (0, react_1.useState)(false), useLogoAfterLocalFailed = _d[0], setUseLogoAfterLocalFailed = _d[1];
    var imageErrorSettled = (0, react_1.useRef)(false);
    var src = logoBrand || (useLogoAfterLocalFailed && logo ? logo : localSrc);
    var handleError = (0, react_1.useCallback)(function () {
        if (imageErrorSettled.current)
            return;
        imageErrorSettled.current = true;
        if (!logoBrand && logo) {
            setUseLogoAfterLocalFailed(true);
        }
    }, [logoBrand, logo]);
    return (react_1.default.createElement(image_1.default, { onClick: onClick, width: 140, height: 35, src: src, alt: (method === null || method === void 0 ? void 0 : method.slug) || '', onError: handleError }));
};
var Slide1 = function () {
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var geoCountry = (0, swr_hooks_1.useGeoCountry)();
    var data = (0, swr_hooks_1.usePublicPayInMethods)(geoCountry).data;
    var profileData = (0, swr_hooks_1.usePayInMethodsProfile)().data;
    var payInData = isAuth
        ? profileData === null || profileData === void 0 ? void 0 : profileData.payIn.getMethods.edges
        : data === null || data === void 0 ? void 0 : data.payInPublic.getMethods.edges;
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var onButtonClick = (0, react_1.useCallback)(function (methodId) {
        if (!methodId) {
            return isAuth ? openDeposit() : openSignUp();
        }
        if (isAuth)
            openDeposit("methodId=".concat(methodId));
        else
            openSignUp();
    }, [openDeposit, openSignUp, isAuth]);
    var getPaymentImagePath = (0, react_1.useCallback)(function (slug) { return "/img/payments/".concat(slug, ".svg"); }, []);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, payInData ? (payInData === null || payInData === void 0 ? void 0 : payInData.map(function (method) {
            var _a, _b;
            return (react_1.default.createElement(FooterPayMethodImage, { key: (_b = (_a = method === null || method === void 0 ? void 0 : method.id) !== null && _a !== void 0 ? _a : method === null || method === void 0 ? void 0 : method.slug) !== null && _b !== void 0 ? _b : '', method: method, onClick: function () { return onButtonClick(method.id); }, getPaymentImagePath: getPaymentImagePath }));
        })) : (react_1.default.createElement(DefaultMethods, { onClick: function () { return onButtonClick(); } })))));
};
var DefaultMethods = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 62, height: 20, src: "/img/footer/payments/visa.svg", alt: "visa" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 52, height: 42, src: "/img/footer/payments/mc.svg", alt: "mastercard" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 71, height: 24, src: "/img/footer/payments/skrill.svg", alt: "skrill" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 119, height: 20, src: "/img/footer/payments/neteller.svg", alt: "neteller" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 118, height: 56, src: "/img/footer/payments/neosurf.svg", alt: "neosurf" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 60, height: 50, src: "/img/footer/payments/interac.svg", alt: "interac" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 105, height: 24, src: "/img/footer/payments/coinspaid.svg", alt: "coinspaid" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 114, height: 22, src: "/img/footer/payments/sofort.svg", alt: "sofort" }),
        react_1.default.createElement(image_1.default, { onClick: onClick, width: 121, height: 34, src: "/img/footer/payments/zimpler.svg", alt: "zimpler" })));
};
exports.default = Slide1;
